/*eslint-disable*/
import PropTypes from "prop-types";
import { PureComponent } from "react";

import Html from "Component/Html";
import Slider from "Component/Slider";
import { DeviceType } from "Type/Device";

import "./Services.style";
import ServicesSlider from "./ServicesSlider";

/**
 * Homepage services
 * @class Services
 * @namespace Component/Services/Component
 */
export class Services extends PureComponent {
    static propTypes = {
        services: PropTypes.object,
        device: DeviceType.isRequired,
    };

    render() {
        const {
            services: { services = [] },
        } = this.props;

        return (
            <div>
                <ServicesSlider services={services} />
            </div>
        );
    }
}

export default Services;
